import React from "react";
import Signin from "./Signin";
import { withRouter } from "react-router-dom";
import AppContext from "../context/appcontext";
import UnAuthorized from "./Common/Errors/Unauthorized";
import * as Constants from "../constants/Constants";
import Cookie from "js-cookie";
import { getUserRolePermission } from "../utils/rolePermissionAccess";
import * as RolePermissionConstants from "../constants/RolePermissionConstants";
import { httpGetVendorProfileByEmail } from "../service/httpClient";
import { getDisableEnableConfig } from "./VendorOnboarding/OnboardingHelper";

class Landing extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.goToHome = this.goToHome.bind(this);
    this.state = {
      showWithDelay: false,
      enableSellerHubFeature: "",
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ showWithDelay: true });
    }, 1000);
    if (
      this.context.roles?.existingUser === Constants.VP_FLAG_Y &&
      Cookie.get("userType") == Constants.VP_USER_TYPE_EXTERNAL
    ) {
      getDisableEnableConfig("sellerCentral", (response) => {
        this.setState({ enableSellerHubFeature: response });
        this.goToHome();
      });
    } else {
      this.goToHome();
    }
  }

  goToHome = () => {
    // This redirectTo cookie added for seller-central tab
    if (
      Cookie.get("userName") &&
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_SELLER_CENTRAL_MANAGE_REPORTS,
        RolePermissionConstants.ALL
      ) === RolePermissionConstants.EDIT
    ) {
      Cookie.set("redirectTo", Constants.SELLER_REPORTS_PAGE_URL, {
        secure: true,
      });
    }
    if (
      this.context.roles?.existingUser === Constants.VP_FLAG_N &&
      Cookie.get("userType") == Constants.VP_USER_TYPE_EXTERNAL
    ) {
      // If redirectTo cookie is not present go to default route
      this.props.history.push(
        Cookie.get("redirectTo") || Constants.VP_WELCOME_PAGE_URL
      );
    } else if (
      this.context.roles?.existingUser === Constants.VP_FLAG_Y &&
      Cookie.get("userType") == Constants.VP_USER_TYPE_EXTERNAL
    ) {
      httpGetVendorProfileByEmail(Cookie.get("email"))
        .then((res) => {
          const vendorDetail = res.data?.vendorDetail;
          const roleName = this.context.roles?.roleName;
          const redirectTo = Cookie.get("redirectTo");
          if (vendorDetail?.liveDate) {
            localStorage.setItem("vid", vendorDetail?.id);
            if (vendorDetail?.merchandiseType === Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE) {
              if (roleName === Constants.EXTERNAL_GENERIC_ADMIN) {
                this.props.history.push(redirectTo || Constants.USER_MANAGEMENT_URL);
              } else {
                this.props.history.push(redirectTo || Constants.SELLER_REPORTS_PAGE_URL);
              }
            } else if (roleName === Constants.EXTERNAL_GENERIC_ADMIN || roleName === Constants.EXTERNAL_VENDOR_GENERIC) {
              this.props.history.push(redirectTo || Constants.VP_DEFAULT_HOME_PAGE_URL);
            } else {
              this.props.history.push(redirectTo || Constants.VP_VOB_HOME_PAGE_URL);
            }
          } else {
            this.props.history.push(redirectTo || Constants.VP_VOB_HOME_PAGE_URL);
          }
        }).catch((err) => console.log("Error redirecting {} ", err));
    } else if (
      Cookie.get("userType") == Constants.VP_USER_TYPE_INTERNAL &&
      this.context.roles?.roleName
    ) {
      if (
        Constants.EXTERNAL_VENDOR_GENERIC === this.context.roles?.roleName ||
        Constants.EXTERNAL_GENERIC_ADMIN === this.context.roles?.roleName
      ) {
        this.props.history.push(
          Cookie.get("redirectTo") || Constants.VP_VOB_HOME_PAGE_URL
        );
      } else {
        this.props.history.push(
          Cookie.get("redirectTo") || Constants.VP_DEFAULT_HOME_PAGE_URL
        );
      }
    }
  };

  render() {
    return (
      <div>
        {Cookie.get("userName") ? (
          <>
            {!this.context.roles && this.state.showWithDelay && (
              <UnAuthorized></UnAuthorized>
            )}
          </>
        ) : (
          <Signin></Signin>
        )}
      </div>
    );
  }
}

export default withRouter(Landing);
